import React,{useState,useEffect} from 'react';
import { Link,useNavigate } from "react-router-dom";
import CheckoutSteps from "./CheckoutSteps";
import { useSelector } from "react-redux";
import MetaData from '../components/MetaData.js';
import { Typography } from "@material-ui/core";
import {setCache,getCache} from './cache.js';

const ConfirmOrder = () => {

	const navigate = useNavigate();
	const { shippingInfo, cartItems } = useSelector((state) => state.cart);
  	const { user } = useSelector((state) => state.user);

  	const [currencySymbol, setCurrencySymbol] = useState("£");
  const [countryCode, setCountryCode] = useState("GB");
  const [isLoading, setIsLoading] = useState(false);

  // Country-to-Currency mapping with exchange rates
  // const countryToCurrency = {
  //   PK: { symbol: "₨", rate: 380 },
  //   US: { symbol: "$", rate: 1.2 },
  //   FR: { symbol: "€", rate: 1.15 },
  //   IN: { symbol: "₹", rate: 100 },
  //   GB: { symbol: "£", rate: 1 },
  // };

  const [countryToCurrency, setCountryToCurrency] = useState({
      PK: { symbol: "₨", currencyCode: "PKR", rate: null },
      US: { symbol: "$", currencyCode: "USD", rate: null },
      FR: { symbol: "€", currencyCode: "EUR", rate: null },
      IN: { symbol: "₹", currencyCode: "INR", rate: null },
      GB: { symbol: "£", currencyCode: "GBP", rate: null },
      AE: { symbol: "AED", currencyCode: "AED", rate: null },
      CN: { symbol: "CNY", currencyCode: "CNY", rate: null },
      SA: { symbol: "SAR", currencyCode: "SAR", rate: null },
    });

    const API_URL = "https://open.er-api.com/v6/latest/GBP"; // Replace with your API endpoint

  //   const fetchExchangeRates = async () => {
  //     try {
  //       const response = await fetch(API_URL);
  //       if (!response.ok) throw new Error("Failed to fetch exchange rates");
  //       const data = await response.json();

  //       setCountryToCurrency((prev) => {
  //         const updatedCurrencies = { ...prev };

  //         Object.keys(updatedCurrencies).forEach((country) => {
  //           const currencyCode = updatedCurrencies[country].currencyCode;
  //           const rate = data.rates[currencyCode];
  //           if (rate) {
  //             updatedCurrencies[country].rate = rate;
  //           }
  //         });

  //         return updatedCurrencies;
  //       });
  //     } catch (error) {
  //       console.error("Error fetching exchange rates:", error);
  //     }
  //   };

  //   // Fetch user's country using their IP address
  //   const fetchUserCountry = async () => {
  //   try {
  //     const response = await fetch("https://get.geojs.io/v1/ip/country.json");
  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  //     const data = await response.json();
  //     return data.country || "GB";
  //   } catch (error) {
  //     console.error("Error fetching user country:", error);
  //     return "GB"; // Default to GB on failure
  //   }
  // };


  //   const loadCurrencyDetails = async () => {
  //   setIsLoading(true);
  //   await fetchExchangeRates();
  //   const userCountry = await fetchUserCountry();
  //   setCountryCode(userCountry);
  //   // Use updated rates
	//   setCountryToCurrency((prev) => {
	//     const currencyInfo = prev[userCountry] || prev["GB"]; // Default to GBP if country not found
	//     setCurrencySymbol(currencyInfo.symbol || "£");
	//     return prev;
	//   });
  //   setIsLoading(false);
  // };

  // useEffect(() => {
  //   loadCurrencyDetails();
  // }, []);

    const CACHE_DURATION = 1 * 10;

    const fetchExchangeRates = async () => {
  const cacheKey = `ExchangeRates:${new Date().toISOString().split('T')[0]}`;
  console.log(`[FETCH] Generated Cache Key: ${cacheKey}`);
  const cachedData = getCache(cacheKey);
  console.log(cachedData)
  if (cachedData) {
    console.log("Exchange rates fetched from cache",new Date());
    return cachedData;
  }

  try {
    const response = await fetch(API_URL);
    if (!response.ok) throw new Error("Failed to fetch exchange rates");

    const data = await response.json();
    setCache(cacheKey, data, CACHE_DURATION);
    console.log("Exchange rates fetched from API");
    return data;
  } catch (error) {
    console.error("Error fetching exchange rates:", error);
    throw error;
  }
};

// Fetch user's country with caching
const fetchUserCountry = async () => {
  const cacheKey = "UserCountry";
  const cachedData = getCache(cacheKey);

  if (cachedData) {
    console.log("User country fetched from cache",new Date());
    return cachedData;
  }

  try {
    const response = await fetch("https://get.geojs.io/v1/ip/country.json");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    const country = data.country || "GB";
    setCache(cacheKey, country, CACHE_DURATION);
    console.log("User country fetched from API");
    return country;
  } catch (error) {
    console.error("Error fetching user country:", error);
    return "GB"; // Default to GB on failure
  }
};

// Load currency details with caching
const loadCurrencyDetails = async () => {
  setIsLoading(true);

  try {
    const exchangeRates = await fetchExchangeRates();
    const userCountry = await fetchUserCountry();

    setCountryToCurrency((prev) => {
      const updatedCurrencies = { ...prev };

      Object.keys(updatedCurrencies).forEach((country) => {
        const currencyCode = updatedCurrencies[country].currencyCode;
        const rate = exchangeRates.rates[currencyCode];
        if (rate) {
          updatedCurrencies[country].rate = rate;
        }
      });

      const currencyInfo = updatedCurrencies[userCountry] || updatedCurrencies["GB"];
      setCurrencySymbol(currencyInfo.symbol || "£");

      return updatedCurrencies;
    });

    setCountryCode(userCountry);
  } catch (error) {
    console.error("Error loading currency details:", error);
  } finally {
    setIsLoading(false);
  }
};

// React useEffect to load data on mount
useEffect(() => {
  loadCurrencyDetails();
}, []);

  	const subtotal = cartItems.reduce((acc, item) => acc + parseFloat((item.price * item.quantity * (1 + item.vat / 100)).toFixed(10)),0);
  	const totalVat = cartItems.reduce((acc, item) => {
	  const vatAmount = (item.price * item.quantity * item.vat) / 100;
	  return acc + vatAmount;
	}, 0);

  const rate = countryToCurrency[countryCode]?.rate || 1;

// Calculate subtotal with localization
const subtotalLocal = cartItems.reduce((acc, item) => {
  const itemTotal = item.price * item.quantity * (1 + item.vat / 100) * rate;
  return acc + parseFloat(itemTotal.toFixed(2));
}, 0);

// Calculate total VAT with localization
const totalVatLocal = cartItems.reduce((acc, item) => {
  const vatAmount = (item.price * item.quantity * item.vat) / 100 * rate;
  return acc + parseFloat(vatAmount.toFixed(2));
}, 0);

  	// const shippingCharges = subtotal > 1000 ? 0 : 200;

  	// const tax = subtotal * 0.20;
  	
  	const totalPrice = subtotal + totalVat;

  	const address = `${shippingInfo.address}, ${shippingInfo.city}, ${shippingInfo.state}, ${shippingInfo.pinCode}, ${shippingInfo.country}`;

  	const proceedToPayment = () => {
	    const data = {
	      subtotal,
	      // shippingCharges,
	      // totalVat,
	      totalPrice,
	    };

	    sessionStorage.setItem("orderInfo", JSON.stringify(data));

	    // navigate("/process/payment");
	    window.location.href = "/process/payment";
	};

	return (
		<>
			<MetaData title="Confirm Order" />
      		<div className="section section-padding update_password">
        	<div className="container">
        	<div className="row">
        		<CheckoutSteps activeStep={1} />
        	</div>
            <div className="row justify-content-center">
	        <div className="col-12">
      		<div className="confirmOrderPage row">

      			<div className="col-lg-8 col-md-12 col-sm-12">
		          <div className="confirmshippingArea">
		            <h3>Order Info</h3>
		            <div className="confirmshippingAreaBox">
		              <div>
		                <p><b>Name:</b></p>
		                <span>{user.name}</span>
		              </div>
		              <div>
		                <p><b>Phone:</b></p>
		                <span>{shippingInfo.phoneNo}</span>
		              </div>
		              <div>
		                <p><b>Address:</b></p>
		                <span>{address}</span>
		              </div>
		            </div>
		          </div>
		          <div className="confirmCartItems">
		            <h3>Your Cart Items:</h3>
		            <div className="confirmCartItemsContainer">
		              {cartItems &&
		                cartItems.map((item) => {
		                	const rate = countryToCurrency[countryCode]?.rate || 1;
						    const symbol = countryToCurrency[countryCode]?.symbol || "£";

						    // Calculate the localized item price (base price)
						    const localizedItemPrice = (item.price * rate).toFixed(2);

						    // Calculate the total item price with VAT applied
						    const totalPriceWithVAT = (
						      item.price * item.quantity * (1 + item.vat / 100) * rate
						    ).toFixed(2);

		                	return(

		                  <div key={item.product}>
		                    <img src={item.image} alt="Product" />
		                    <h6><Link to={`/product/${item.product}`}>
		                      {item.name}
		                    </Link></h6>
		                    <span>
		                      {item.quantity} X £{item.price}
								{symbol !== "£" && (
									<span>(<i className="fs-6">≈ </i><span className="text-muted" style={{fontSize:"12px"}}>{symbol}{localizedItemPrice}</span>)</span>
									)}
								<span> +</span> VAT {item.vat}% = <b> £{(item.price * item.quantity * (1 + item.vat / 100)).toFixed(2)}</b>
		                    </span>
		                    {/*<span>
								          {item.quantity} X {symbol}
								          {localizedItemPrice} + VAT {item.vat}% = 
								          <b className="mx-1">
								            {symbol}
								            {totalPriceWithVAT}
								          </b>
								        </span>*/}
		                  </div>
		                );
		                })}
		            </div>
		          </div>
		        </div>
		        <div className="col-lg-4 col-md-12 col-sm-12">
		        <div className="orderSummary">
		            <h3>Order Summery</h3>
		              <div>
		                <p><b>Subtotal:</b></p>
		                {/*<span>£{subtotal} <sub>{currencySymbol}{subtotalLocal}</sub></span>*/}
		                <span>£{subtotal}
							{currencySymbol !== "£" && (
								<span>(<i className="fs-6">≈ </i><span className="text-muted" style={{fontSize:"12px"}}>{currencySymbol}{subtotalLocal.toFixed(2)}</span>)</span>
							)}
						</span>
		              </div>
		              {/*<div>
		                <p><b>Shipping Charges:</b></p>
		                <span>${shippingCharges}</span>
		              </div>*/}
		              <div>
		                <p><b>VAT:</b></p>
						  <span>£{totalVat.toFixed(2)}
							  {currencySymbol !== "£" && (
								  <span>(<i className="fs-6">≈ </i><span className="text-muted" style={{fontSize:"12px"}}>{currencySymbol}{totalVatLocal.toFixed(2)}</span>)</span>
								  )}
						  </span>
		              </div>

		            <div className="orderSummaryTotal">
		              <p>
		                <b>Total:</b>
		              </p>
		              {/*<span>£{subtotal} <sub>{currencySymbol}{subtotalLocal}</sub></span>*/}
		              <span>£{subtotal}
						  {currencySymbol !== "£" && (
							  <span>(<i className="fs-6">≈ </i><span className="text-muted" style={{fontSize:"12px"}}>{currencySymbol}{subtotalLocal.toFixed(2)}</span>)</span>
							  )}
						  </span>

		            </div>

		            <button className="btn btn-primary btn-hover-dark" onClick={proceedToPayment}>Proceed To Payment</button>
		        </div>
		        </div>
		    </div>
		    </div>
		    </div>
		    </div>
		    </div>
		</>
	)
}

export default ConfirmOrder